import React from "react";
import { FaRedo, FaPlus } from "react-icons/fa";

const ReservationFilters = ({
  filters,
  setFilters,
  toggleForm,
  showForm,
  hotelOptions = [],
}) => {
  const handleChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleReset = () => {
    setFilters({
      searchTerm: "",
      hotelId: "",
      status: "All",
      startDate: "",
      endDate: "",
    });
  };
  return (
    <div className="d-flex align-items-center gap-2">
      {!showForm && (
        <>
          {/* <input
            type="text"
            className="form-control w-auto"
            name="searchTerm"
            style={{ minWidth: "200px" }}
            placeholder="Search"
            value={filters.searchTerm}
            onChange={handleChange}
          /> */}
          {/* Hotel Filter */}
          <input
            type="date"
            name="startDate"
            className="form-control"
            value={filters.startDate}
            onChange={handleChange}
          />
          <input
            type="date"
            name="endDate"
            className="form-control"
            value={filters.endDate}
            onChange={handleChange}
          />
          <select
            className="form-select"
            name="hotelId"
            value={filters.hotelId}
            onChange={handleChange}
            style={{ minWidth: "160px" }}
          >
            <option value="">All Hotels</option>
            {hotelOptions.map((h) => (
              <option key={h.value} value={h.value}>
                {h.label}
              </option>
            ))}
          </select>
          <select
            className="form-select"
            name="status"
            value={filters.status}
            onChange={handleChange}
          >
            <option value="All">All</option>
            <option value="reservation">Reservation</option>
            <option value="check-in">Check-in</option>
            <option value="check-out">Check-out</option>
            <option value="cancelled">Cancelled (hide)</option>
            <option value="no-show">No-show</option>
            <option value="unconfirmed reservation">
              Unconfirmed Reservation
            </option>
          </select>

          {/* Reset Button with Icon */}
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleReset}
          >
            <FaRedo style={{ marginRight: "0.5rem" }} />
          </button>
          <button className="btn btn-secondary" onClick={toggleForm}>
            {!showForm && <FaPlus style={{ marginRight: "0.5rem" }} />}

            {/* {showForm ? "Close Form" : <FaPlus style={{ marginRight: "0.5rem" }} />} */}
          </button>
        </>
      )}
    </div>
  );
};

export default ReservationFilters;
